// Brief
export const selectCurrentBrief = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.currentBrief;

export const selectCurrentBriefId = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.currentBriefId;

export const selectCurrentBriefLoading = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.currentBriefLoading;

export const selectBriefVersions = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.briefVersions;

export const selectPreviewBriefVersion = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.briefPreviewVersion;

export const selectBriefProgress = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.briefProgress;

export const selectBriefTimings = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.briefTimings;

export const selectBriefQuestions = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.briefQuestions;

export const selectBriefCitations = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.briefCitations;

// Htags
export const selectRanksHtags = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.ranksHtags;

export const selectIsRanksHtagsLoaded = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.isRanksHtagsLoaded;

export const selectAIBriefLoading = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.aiBriefLoading;

export const selectAIContentLoadingField = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.aiContentLoadingField;

export const selectAIContentLoading = (state) => !!selectAIContentLoadingField(state);

export const selectAIContentLoadingProgress = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.aiContentLoadingProgress;

export const selectAIOutlineLoadingProgress = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.aiOutlineLoadingProgress;

export const selectOutlineVersionLoading = (state) =>
    state?.contentOptimizer?.contentBriefsOutline?.outlineVersionLoading;
